import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import RoomsMenu from '../RoomsMenu/RoomsMenu';
import { changeIsMainMenuOpened, changeIsSummaryOpened } from '../../model/configuratorSlice';
import { MainMenuButton } from '../../shared/svg/components';
import { MyProfileState } from '../../model/constants';

const SubHeader = ({ isMobilePortrait }) => {
  const { currentUnit, promotionSlug } = useSelector(state => state.configurator);


  return (
    <div className="subheader-container">
      {/* <div className="container-client-promotion">
        <img
          src={`${process.env.PUBLIC_URL}/promotion/${promotionSlug}s.png`}
          alt=""
        />
      </div> */}
      {/* <button className="menu-button" type="button" onClick={() => openMenu()}>
        <MainMenuButton />
      </button> */}

      {!isMobilePortrait ? <RoomsMenu /> : null}
    </div>
  );
};

SubHeader.propTypes = {
    isMobilePortrait: PropTypes.bool.isRequired,
};

export default SubHeader;
